import { render, staticRenderFns } from "./ModerationControl.vue?vue&type=template&id=1ac49054&scoped=true"
import script from "./ModerationControl.vue?vue&type=script&lang=js"
export * from "./ModerationControl.vue?vue&type=script&lang=js"
import style0 from "./ModerationControl.vue?vue&type=style&index=0&id=1ac49054&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac49054",
  null
  
)

export default component.exports